module.exports = __webpack_public_path__ + "35734b08b3c668e4ca40d3198bff32bc.pdf";